import React, { useState } from 'react';
import {Chessboard} from 'react-chessboard';
import ChessXplain from './chessXplain.js'


function App() {

  return (
    <ChessXplain/>
  );
}

export default App;
